import {HotelExtraFeatureType} from './hotel-extra-feature-type.model';
export class HotelExtraFeature {
  description: string;
  price: number;
  constructor(type: HotelExtraFeatureType, description: string, price: number = 0) {
    this.description = description;
    this.price = price;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/hotel/hotel-extra-feature.model.ts